import * as React from 'react';
import {FunctionComponent} from 'react';
import {observer} from 'mobx-react-lite';
import {PresenterProps, withPresenter} from '../../../support/with_presenter';
import {ChapterInsertPresenter} from './ChapterInsertPresenter';
import {ExpandedPart} from '../../../business/expanded_parts/ExpandedPartsProvider';
import {Chapter} from '../../../models/Chapter';

interface OwnProps {
    expandedPart: ExpandedPart;
    chapters: Chapter[];
}

const ChapterInsertComponent: FunctionComponent<OwnProps & PresenterProps<ChapterInsertPresenter>> = observer(
    ({presenter, chapters}) => {
        return (
            <div className="chapter-insert">
                {chapters.map((chapter) => (
                    <div key={chapter.__uuid} className="chapter-insert__item">
                        <div className="chapter-insert__thumbnail">
                            {chapter.thumbnail_url !== null && <img src={chapter.thumbnail_url} />}
                        </div>
                        <div className="chapter-insert__title">{chapter.title}</div>
                        <button
                            className="chapter-insert__trash ion-md-trash"
                            onClick={() => presenter.onTrashChapter(chapter)}
                        />
                    </div>
                ))}
            </div>
        );
    },
);

export const ChapterInsert = withPresenter<ChapterInsertPresenter, OwnProps>(
    (props, component) => new ChapterInsertPresenter(component.chaptersInteractor),
    ChapterInsertComponent,
);
